const prependPrefix = (str: string, prefix?: string, joint = '_') =>
  [prefix, str].filter(Boolean).join(joint);

export default prependPrefix;
